
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmVimeo,
  VmEmbed 
} from '@vime/core';

import { define } from '../lib';
  

const VimeoInputs: string[] = [
  'videoId',
  'byline',
  'color',
  'portrait',
  'noAutoAspectRatio',
  'poster',
  'cookies',
  'language',
  'aspectRatio',
  'autoplay',
  'controls',
  'logger',
  'loop',
  'muted',
  'playsinline',
];

const VimeoMethods: string[] = [
  'getAdapter',
];

const VimeoOutputs: string[] = [
  'vmError',
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface Vimeo extends Components.VmVimeo {}

@ProxyCmp({
  inputs: VimeoInputs,
  methods: VimeoMethods,
})
@Component({
  selector: 'vm-vimeo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: VimeoInputs,
  outputs: VimeoOutputs,
})
export class Vimeo {
  protected el: HTMLElement;

  /** Emitted when an error has occurred. */
  vmError!: Emitter<JSX.VmVimeo["onVmError"]>;

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-vimeo', VmVimeo);
    define('vm-embed', VmEmbed);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, ['vmError'])
  }
}
  